import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Toolstack from "./Toolstack";
import WorkExperience from "./WorkExperience";
import Education from "./Education";
import { usePortfolioSettings } from "../../hooks/usePortfolioData";

function About() {
  const { settings } = usePortfolioSettings();

  // Settings are already loaded by the hook, no need to refetch
  
  // Fallback to default - handle null/empty explicitly
  const aboutAvatarImage = (settings?.about_avatar_image && settings.about_avatar_image.trim() !== '') 
    ? settings.about_avatar_image 
    : '/Assets/avatar.png';

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <br></br>
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
            LET ME <strong className="purple">INTRODUCE MYSELF</strong>
            </h1>
            <Aboutcard />

          </Col>
          <Col
            md={4}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img 
              src={aboutAvatarImage} 
              alt="about" 
              className="img-fluid"
              onError={(e) => {
                e.target.src = '/Assets/avatar.png';
              }}
            />
          </Col>

        </Row>
        
        <WorkExperience />
        
        <Education />
        
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
